import { create } from 'zustand';

/**
 * Viewport focus (R5): with the 3D quad layout, four engine viewports
 * share one document. Interaction layers (command scope, dynamic input
 * bridge, active tool, gumball) must run in the FOCUSED viewport only —
 * the store keeps the id of the viewport that last received a pointer.
 * 'main' is the implicit focus of every single-viewport shell, so the
 * CAD/BIM workbenches never touch this store.
 */
interface ViewportFocusState {
    focus: string;
    setFocus: (id: string) => void;
}

export const useViewportFocus = create<ViewportFocusState>((set) => ({
    focus: 'main',
    setFocus: (focus) => set({ focus }),
}));

/** True when the given viewport id owns interaction (or is the main one). */
export function viewportOwnsInteraction(id: string | undefined): boolean {
    const { focus } = useViewportFocus.getState();
    return !id || id === focus || focus === 'main';
}
